import type { FunctionComponent } from "react";

import type {
	CentralInvoiceRecipient,
} from "~/modules/billing/api/centralInvoiceRecipient/centralInvoiceRecipientTypes.ts";
import CentralInvoiceRecipientContactCard
	from "~/modules/client/components/ClientDetailsView/components/ClientsInvoiceRecipientsList/components/CentralInvoiceRecipientContactCard.tsx";
import NewFirstItemCta from "~/modules/client/components/ClientDetailsView/components/NewFirstItemCta";
import { byObjectProperty } from "~/utils/sortFunctions.ts";

interface ClientsInvoiceRecipientsListProps {
	clientDisplayName: string;
	invoiceRecipients?: CentralInvoiceRecipient[];
	onAddInvoiceRecipientClick: () => void;
}

const ClientsInvoiceRecipientsList: FunctionComponent<ClientsInvoiceRecipientsListProps> = ({
	clientDisplayName,
	invoiceRecipients,
	onAddInvoiceRecipientClick,
}) => {
	return (
		<>
			{(invoiceRecipients && 0 === invoiceRecipients.length) &&
				<NewFirstItemCta buttonText="Neuen Rechnungsempfänger
							anlegen"
								 headline="Noch keine zentralen Rechnungsempfänger vorhanden"
								 onCreateClick={onAddInvoiceRecipientClick}
								 subLineText={`Füge neue Kontakte zu ${clientDisplayName} hinzu.`} />

			}
			{invoiceRecipients && invoiceRecipients?.length > 0 &&
				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{invoiceRecipients.sort(byObjectProperty("displayName")).map(invoiceRecipient => (
						<CentralInvoiceRecipientContactCard
							key={invoiceRecipient.id}
							invoiceRecipient={invoiceRecipient}
						/>
					))}
				</div>}
		</>
	);
};

export default ClientsInvoiceRecipientsList;
